module.exports = __webpack_public_path__ + "img/6.3d2722b3.png";